exports.setCookie = setCookie;
exports.getCookie = getCookie;
exports.cookieResponseclear = cookieResponseclear;

/* cookies functions*/
function setCookie (cname, cvalue, exdays, timestamp) {
    let d;
    if (!exdays && timestamp) {
        d = new Date(timestamp);
    } else if (exdays) {
        d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    }
    let expires = d ? `; expires=${d.toUTCString()}` : "";
    document.cookie = `${cname}=${cvalue}${expires}; path=/`;
}

function getCookie (cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function cookieResponseclear () {
    setCookie('favoritesTours', "");
    return "";
}




// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/cookies.js